import { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../app/hooks";
import { fetchProductSummary, selectProductSummary } from "../features/store/products/product.slice";

const useProductSummary = () => {
    const dispatch = useAppDispatch();
    const summary = useAppSelector(selectProductSummary);

    const getProductSummary = async () => {
        await dispatch(fetchProductSummary());
    }

    useEffect(() => {
        getProductSummary();
    }, []);

    return summary;
}
 
export default useProductSummary;